

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const paymentMadeAtom = atom({key:'paymentMadeAtom2', default:{
    payment_through:[],
    vendor:[],
    payment_info:[],
    tax_info:[]

}});

const paymentMadeEditAtom = atom({key:'paymentMadeEditAtom2', default:{payment_info: [],
    bill_info: []}});




export  const SetPaymentMadeAtom = () => useSetRecoilState(paymentMadeAtom);
export  const GetPaymentMadeAtom = () => useRecoilValue(paymentMadeAtom);

export  const SetPaymentEdit = () => useSetRecoilState(paymentMadeEditAtom);
export  const GetPaymentEdit = () => useRecoilValue(paymentMadeEditAtom);
export const ResetPaymentEdit = ()=> useResetRecoilState(paymentMadeEditAtom);









